export class PasswordValidar {
    usuario: string;
    email: string;
}
